import { render, staticRenderFns } from "./customs-transit.vue?vue&type=template&id=259e653e&"
import script from "./customs-transit.vue?vue&type=script&lang=js&"
export * from "./customs-transit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports